<!--推荐人管理-->

<template>
  <div class="custom-tree-container">
    <div class="block">
      <el-tree
          :data="dataList"
          :expand-on-click-node="false"
          :highlight-current="true"
          :props="{ children: 'Children' }"
          default-expand-all
          node-key="Id">
      <span slot-scope="{ node, data }" class="custom-tree-node">
          <div><strong>推荐人:</strong> {{ data.Name }}</div>
          <div><strong>推荐码:</strong> {{ data.ReferralCode }}</div>
          <div><strong>创建时间:</strong> {{ data.CreateTime }}</div>
        <span>
          <el-button
              size="mini"
              type="text"
              @click="handleShow(data)">
            查看
          </el-button>
        </span>
      </span>
      </el-tree>
    </div>
    <!-- 弹框部分 -->
    <el-dialog v-model="editFormVisible" :close-on-click-modal="false" :visible.sync="editFormVisible" title="查看"
               width="50%">
      <el-descriptions title="用户信息" :column="2" >
        <el-descriptions-item label="头像">
          <el-avatar :size="40" :src="editForm.AvatarUrl"></el-avatar>
        </el-descriptions-item>
        <el-descriptions-item label="用户名">{{editForm.name}}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{editForm.Phone}}</el-descriptions-item>
        <el-descriptions-item label="推荐码">{{editForm.UUID}}</el-descriptions-item>
        <el-descriptions-item label="VIP过期时间">
          <el-tag size="small">{{editForm.MembershipExpiryDate}}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="联系地址">{{editForm.addr}}</el-descriptions-item>

      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">确定</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import util from "../../../util/date";
import {
  getTreeReferrers,
  info
} from "../../api/api";
import {
  getButtonList
} from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: {},
  data() {
    return {
      dataList: [],
      nodeKey: 'Id',
      showDialog: false,
      editFormVisible: false,
      editForm: {
        Name: '',
        Avatar: '',
        Phone: '',
        Address: '',
        ReferralCode: '',
        Mobile: '',
      }
    };
  },
  methods: {
    //获取树形列表
    handleQuery() {
      getTreeReferrers().then((res) => {
        this.dataList = res.data.response;
        console.log("获取树形列表", this.dataList)
        this.listLoading = false;
        //NProgress.done();
      });
    },
    handleShow(data) {
      console.log("handleShow", data)
      let param={Id:data.UserId};
      info(param).then(res => {
        this.editForm = res.data.response;
      });
      this.editFormVisible = true; // 打开弹框
    }


  },
  mounted() {
    this.handleQuery();
  },
};
</script>


<style scoped>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>